import axios from 'axios';

// Create axios instance with interceptors for session management
const setupAxiosInterceptors = () => {
  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const status = error.response.status;
        
        // Handle 401 Unauthorized - Token expired or invalid
        if (status === 401) {
          const currentPath = window.location.pathname;
          
          // Only redirect if we're in the POS app area
          if (currentPath.startsWith('/gposp') && !currentPath.includes('/login') && !currentPath.includes('/register')) {
            // Clear stored tokens
            localStorage.removeItem('pos_token');
            localStorage.removeItem('pos_store_id');
            localStorage.removeItem('pos_business_name');
            
            // Show alert and redirect
            alert('Your session has expired. Please login again.');
            window.location.href = '/gposp/login';
            return Promise.reject(error);
          }
        }
        
        // Handle 403 Forbidden - No permission
        if (status === 403) {
          console.error('Access forbidden:', error.response.data);
        }
      }
      
      return Promise.reject(error);
    }
  );

  // Request interceptor to add token automatically
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('pos_token');
      
      // Only add token for POS API calls
      if (token && config.url && config.url.includes('/api/pos')) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      
      return config;
    },
    (error) => Promise.reject(error)
  );
};

export default setupAxiosInterceptors;
